@if (appConfigService.features[AppFeature.EnableCalling] && appConfigService.features[AppFeature.WebPopIntegration]) {
  <div class="header-container">
    <button
      color="primary"
      mat-raised-button
      type="button"
      (click)="refreshIntegrations()"
      appBrandingColor
      [brandingField]="BrandingField.FieldColorFontIconsListAreaItems">
      <div class="button-content">
        @if (integrationsService.isLoading$ | async) {
          <mat-progress-spinner
            class="whiteSpinner"
            diameter="24"
            mode="indeterminate"></mat-progress-spinner>
        } @else {
          <mat-icon>refresh</mat-icon>
        }
        <span>{{ 'INTEGRATIONS_PREFERENCES.REFRESH_INTEGRATIONS' | translate }}</span>
      </div>
    </button>
  </div>
}

<div class="sections">
  @if (!isRunningInElectron) {
    <div>
      <h4>{{ 'INTEGRATIONS_PREFERENCES.BROWSER_INTEGRATION' | translate }}</h4>
      <mat-divider></mat-divider>
      <p>{{ 'INTEGRATIONS_PREFERENCES.BROWSER_INTEGRATION_DESCRIPTION' | translate }}</p>

      <div class="btn-group">
        <!--    (click)="save(currentPage)"-->
        @let isPwaInstalled = pwaService.pwaInstalled$ | async;
        <button
          color="primary"
          mat-raised-button
          class="m-l-12"
          type="button"
          [disabled]="isPwaInstalled"
          (click)="installConnectUCPwa()"
          [matTooltip]="'INTEGRATIONS_PREFERENCES.INSTALL_BUTTON_TOOLTIP' | translate"
          appBrandingColor
          [brandingField]="BrandingField.FieldColorFontIconsListAreaItems">
          <mat-icon style="transform: rotate(180deg)"> publish</mat-icon>
          <span>{{ 'INTEGRATIONS_PREFERENCES.INSTALL_BUTTON' | translate }}</span>
        </button>
        @if (appConfigService.features[AppFeature.EnableCalling]) {
          <button
            color="primary"
            mat-stroked-button
            class="m-l-12"
            type="button"
            [disabled]="!isPwaInstalled || protocolHandlerService.isRegistered('tel')"
            (click)="registerTelHandler()"
            [matTooltip]="'INTEGRATIONS_PREFERENCES.REGISTER_FOR_ONE_CLICK_TOOLTIP' | translate"
            appBrandingColor
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
            styleType="color">
            <span>{{ 'INTEGRATIONS_PREFERENCES.REGISTER_FOR_ONE_CLICK' | translate }}</span>
          </button>
        }
      </div>
    </div>
  }

  @if (appConfigService.features[AppFeature.EnableCalling] && appConfigService.features[AppFeature.WebPopIntegration]) {
    <div>
      <h4>{{ 'INTEGRATIONS_PREFERENCES.AVAILABLE_WEBPOP_INTEGRATIONS' | translate }}</h4>
      <mat-divider></mat-divider>
      <p>{{ 'INTEGRATIONS_PREFERENCES.AVAILABLE_WEBPOP_INTEGRATIONS_DESCRIPTION' | translate }}</p>

      @let isLoading = integrationsService.isLoading$ | async;
      @if (isLoading) {
        <mat-spinner [diameter]="20"></mat-spinner>
      } @else {
        <div class="settings-item-container">
          @let integrations = integrationsService.integrations$ | async;
          @if (integrations && integrations.length > 0) {
            @for (integration of integrations; track integration.id) {
              <app-integration-settings-item
                [integration]="integration"
                (integrationChanged)="handleIntegrationUpdated($event)">
              </app-integration-settings-item>
              <mat-divider />
            }
            <div class="webpopConfiguration">
              <h4>{{ 'INTEGRATIONS_PREFERENCES.AUTO_POP_INCOMING_TIMEOUT' | translate }}</h4>
              <mat-divider></mat-divider>
              <p>{{ 'INTEGRATIONS_PREFERENCES.AUTO_POP_INCOMING_TIMEOUT_HELP' | translate }}</p>
              <mat-form-field
                appearance="outline"
                class="density-minus-3">
                <input
                  matInput
                  type="number"
                  min="1"
                  max="15"
                  [formControl]="autoPopDigitsInbound" />
              </mat-form-field>
              <h4>{{ 'INTEGRATIONS_PREFERENCES.AUTO_POP_OUTGOING_TIMEOUT' | translate }}</h4>
              <mat-divider></mat-divider>
              <p>{{ 'INTEGRATIONS_PREFERENCES.AUTO_POP_OUTGOING_TIMEOUT_HELP' | translate }}</p>
              <mat-form-field
                appearance="outline"
                class="density-minus-3">
                <input
                  matInput
                  type="number"
                  min="1"
                  max="15"
                  [formControl]="autoPopDigitsOutbound" />
              </mat-form-field>
              <div>
                <h4 class="advanced-configuration-logs-button">
                  {{ 'INTEGRATIONS_PREFERENCES.ADVANCED_CONFIGURATION_LOGS' | translate }}
                </h4>

                @let logs = (lambdaService.logs$ | async) || [];
                @if (logs.length > 0) {
                  <mat-accordion [displayMode]="'flat'">
                    @for (log of logs; track log.createdAt) {
                      <mat-expansion-panel>
                        <mat-expansion-panel-header>
                          <mat-panel-title> {{ log.integrationTitle }} </mat-panel-title>
                          <mat-panel-description> {{ log.createdAt | date: 'mediumDate' }} </mat-panel-description>
                        </mat-expansion-panel-header>
                        <app-lambda-output-details
                          [lambdaOutput]="log"
                          (downloadFileBtnClicked)="handleDownloadLogClick(log)" />
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                } @else {
                  <div class="no-logs">
                    {{ 'INTEGRATIONS_PREFERENCES.NO_LOGS' | translate }}
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }

  <div>
    <app-identity-providers></app-identity-providers>
  </div>
</div>
